import React from 'react';
import { FormEmail } from '@uncinc/uncinc-react-kitchen-sink';

const EmailField = (props) => {
  return (
    <FormEmail {...props} />
  );
};

export default EmailField;
